//
// Aktuelles, Masonry
//

// #12325 - Disable Masonry to prevent error in layout (due to use of same height images)
//import Masonry from 'masonry-layout'; 

function masonryinit() {
  const containers = document.querySelectorAll('.aktuelles-list') || [];

  containers.forEach((container) => {
    const numItems = parseInt(container.dataset.items);

    if (numItems) {
      const items = container.querySelectorAll('.aktuelles-item') || [];

      items.forEach((item, index) => {
        if (index > (numItems - 1)) {
          item.hidden = true;
        }
      });
    }

    /* #12325 - Disable Masonry to prevent error in layout (due to use of same height images)
    const masonry = new Masonry(container, {
      itemSelector: '.aktuelles-item',
      transitionDuration: 0,
      stagger: 0,
    });
    */

    const loadMoreButton = container.querySelector('.load-more-masonry');

    if (!loadMoreButton) {
      return;
    }

    loadMoreButton.addEventListener('click', () => {
      const items = container.querySelectorAll('.aktuelles-item[hidden]') || [];

      for (let index = 0; index < numItems; index++) {
        if (items[index]) {
          items[index].hidden = false;

          //masonry.layout();
        }
      }

      const remainingItems = container.querySelectorAll('.aktuelles-item[hidden]') || [];

      if (remainingItems.length === 0) {
        loadMoreButton.hidden = true;
      }
    });
  });
}

window.onload = function () {
  masonryinit();
};


export default {};
